module.exports = __webpack_public_path__ + "img/logo-default.9334616a.png";